module.exports = __webpack_public_path__ + "static/img/7.8efd3b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/7.png
// module id = Sblk
// module chunks = 0